import React from 'react';
import PropTypes from 'prop-types';
import { isValid, format, parseISO } from 'date-fns';

import { interpolateMany } from 'utilities/interpolate';
import { getProductName } from 'utilities/huggg';

import dictionary from 'config/dictionary';
import styles from './expiration-date.module.scss';

const ExpirationDate = (props) => {
  const { huggg, voucherExpiry } = props;
  const { isSuperhuggg } = huggg;

  const expiryDate = isSuperhuggg
    ? huggg.expiry
    : (voucherExpiry ?? huggg.expiry_date);

  const template = dictionary.stash.expirationRedesign;

  return expiryDate
    ? isValid(new Date(expiryDate)) && (
        <div className={styles.container}>
          <span className={styles.text}>
            {interpolateMany(template, [
              [
                '[expiration_date]',
                <strong key={null} className={styles.date}>
                  {format(parseISO(expiryDate), 'do MMM yyyy')}
                </strong>,
              ],
              ['[product_name]', <>{getProductName(huggg)}</>],
            ])}
          </span>
        </div>
      )
    : null;
};

ExpirationDate.propTypes = {
  huggg: PropTypes.object.isRequired,
  voucherExpiry: PropTypes.string,
};

export default ExpirationDate;
